<style >
html,
body,
#app {
  height: 100%;
    height: 100vh;overflow-x: hidden;
}
.el-header {
  text-align: center;
  /* line-height: 8px; */
  padding: 0;
  /* height: 120px !important; */
  /* border-bottom: 1px solid #dcdfe6; */
  text-align: left;
  margin-bottom: 20px;
}

.el-aside {
  color: #333;
  text-align: center;
  line-height: 200px;
}

.el-main {
  color: #333;
  text-align: center;
  /*line-height: 160px;*/
}

.logo {
  color: #666;
  font-size: 18px;
  line-height: 80px;
}
.logo img {
  transform: scale(0.8);
  display: inline-block;
  vertical-align: middle;
  margin-top: -5px;
  margin-right: -10px;
}

.top-menu {
  border-bottom: 0 !important;
  margin-top: 10px;
}
.top-menu a {
  display: block;
  line-height: 60px;
  height: 60px;
  font-size: 18px;
}
.xingluo-components-page-head{
  width:1310px !important;
}
</style>

<template>
  <div id="app">
    <!-- 登陆 注册用一个view -->
    <div v-if="v=='login'" style="height: 100%">
      <router-view/>
    </div>

    <!-- 登陆后 -->
    <div v-if="v==null">
      <myhead :router="router"></myhead>
      <router-view/>
    </div>
  </div>
</template>

<script>
import myhead from "./views/structure/myhead";
export default {
  name: "app",
  data() {
    return {
      v: null, //login null 默认login登陆后null
      user_info: "",
      router: "",
      path: "",
      isvip: "" //1为普通用户 2为招商用户
    };
  },
  components: {
    myhead: myhead
  },
  created() {
    // this.isvip = this.$http.getAuth("user_info").type;
  },
  watch: {
    // 对路由变化作出响应...
    $route: {
      handler: function() {
        this.getRout();
      },
      immediate: true
    }
  },
  mounted() {
    window.location.href = 'https://www.haohuo.com/'
    this.v = this.$http.getAuth("auth_token") ? null : "login";
    sessionStorage.setItem("setType", 1);
    // this.getStatus();
  },
  methods: {
    getRout() {
      let _this = this;
      let path = this.$route.path;
      let a = path.split("/")[1] || "";
      this.router = a;
      this.v = this.$http.getAuth("auth_token") ? null : "login";
      if (a == "login") {
        this.$http.removeAuth();
      }
      //招商人员不能进入商品中心
      let hash=window.location.hash;
      if (a == "goods" && this.isvip == 2) {
        this.$router.back(-1);
      }
      if (this.$http.getAuth("user_info")) {
        if (
          hash.indexOf('my')!=-1
          // window.location.hash == "#/my/myinfo" ||
          // window.location.hash == "#/my/mypid" ||
          // a == "my" ||
          // window.location.hash == "#/my/api" ||
          // window.location.hash == "#/my/server" ||
          // window.location.hash == "#/my/heads?type=2" ||
          // window.location.hash == "#/my/heads?type=1"
        ) {
        } else {
          this.getStatus();
        }
      }
    },
    getStatus() {
      let user_info = this.$http.getAuth("user_info");
      let path = this.$route.path;
      let a = path.split("/")[1] || "";
      if (user_info && user_info != "" && user_info.status != 2&&a != "forgot") {
        this.$router.push({
          name: "auth",
          query: {}
        });
      }
    }
  }
};
</script>


